export const humanFileSize = (bytes, dp = 1) => {
    const thresh = 1024;

    if (bytes === 0) {
        return 0;
    }

    if (Math.abs(bytes) < thresh) {
        return bytes + 'o';
    }

    const units = ['Ko', 'Mo', 'Go'];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


    return bytes.toFixed(dp) + units[u];
}
